import { render, staticRenderFns } from "./OccurrenceTypePersistView.vue?vue&type=template&id=426408c0"
import script from "./OccurrenceTypePersistView.vue?vue&type=script&lang=ts"
export * from "./OccurrenceTypePersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports